import dayjs from "dayjs";

const EditPfAccountDetails = ({ formData, handleInputChange }) => {
  return (
    <div>
      <p className="text-xl my-2 p-2 border-l-2 border-purple-300 font-semibold">
        PF Account Details
      </p>
      <div>
        <div className="flex gap-16">
          <div>
            <h4 className="text-slate-600">UAN Number</h4>
            <input
              type="text"
              name="uanNumber"
              value={formData?.pfAccountDetails?.uanNumber || ""}
              className="border rounded-md my-2 px-2 py-1"
              onChange={handleInputChange}
            />
          </div>
          <div>
            <h4 className="text-slate-600">PF Number</h4>
            <input
              type="text"
              name="pfNumber"
              value={formData?.pfAccountDetails?.pfNumber || ""}
              className="border rounded-md my-2 px-2 py-1"
              onChange={handleInputChange}
            />
          </div>{" "}
          <div>
            <h4 className="text-slate-600">PF Join Date</h4>
            <input
              type="date"
              name="pfJoinDate"
              value={dayjs(formData?.pfAccountDetails?.pfJoinDate).format(
                "YYYY-MM-DD"
              )}
              className="border rounded-md my-2 px-2 py-1"
              onChange={handleInputChange}
            />
          </div>{" "}
          <div>
            <h4 className="text-slate-600">Family PF Number</h4>
            <input
              type="text"
              name="familyPfNumber"
              value={formData?.pfAccountDetails?.familyPfNumber || ""}
              className="border rounded-md my-2 px-2 py-1"
              onChange={handleInputChange}
            />
          </div>
        </div>
        <div className="flex flex-col w-full gap-5 mt-5">
          <div className="flex gap-16 w-max">
            <div>
              <label
                for="isExistingNumberofEPS"
                className="text-sm font-medium text-gray-700  mr-3"
              >
                Is the Existing Number of EPS.{" "}
              </label>
              <input
                checked={formData.pfAccountDetails?.isExistingNumberofEPS}
                type="checkbox"
                id="isExistingNumberofEPS"
                name="isExistingNumberofEPS"
                onClick={handleInputChange}
                className={"w-[1.2rem] h-[1.2rem]"}
              />
            </div>

            <div>
              <label
                for="allowEPFExcessContribution"
                className="text-sm font-medium text-gray-700  mr-3"
              >
                Allow EPF Excess Contribution.{" "}
              </label>
              <input
                checked={formData.pfAccountDetails?.allowEPFExcessContribution}
                type="checkbox"
                id="allowEPFExcessContribution"
                name="allowEPFExcessContribution"
                onClick={handleInputChange}
                className={"w-[1.2rem] h-[1.2rem]"}
              />
            </div>
          </div>

          <div className="flex gap-16 w-max">
            <div>
              <label
                for="allowEPSExcessContribution"
                className="text-sm font-medium text-gray-700  mr-3"
              >
                Allow EPS Excess Contribution.{" "}
              </label>
              <input
                checked={formData.pfAccountDetails?.allowEPSExcessContribution}
                type="checkbox"
                id="allowEPSExcessContribution"
                name="allowEPSExcessContribution"
                onClick={handleInputChange}
                className={"w-[1.2rem] h-[1.2rem]"}
              />
            </div>

            <div>
              <label
                for="isPfKycVerified"
                className="text-sm font-medium text-gray-700  mr-3"
              >
                PF KYC completed.{" "}
              </label>
              <input
                checked={formData.pfAccountDetails?.isPfKycVerified}
                type="checkbox"
                id="isPfKycVerified"
                name="isPfKycVerified"
                onClick={handleInputChange}
                className={"w-[1.2rem] h-[1.2rem]"}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditPfAccountDetails;
